<template>
    <Transition name="pop">
        <div id="bindPop" class="pop" v-if="state.bind.show">
            <div class="content">
                <span class="close" @click="state.bind.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>角色绑定</h1>
                <template v-if="state.bind.list.length > 0">
                    <div class="select-wrapper">
                        <select ref="roleRef" v-model="state.bind.role">
                            <option value="">--请选择角色--</option>
                            <option
                                :value="`${item.RoleName}`"
                                v-for="item in state.bind.list"
                                :key="item.RoleName"
                            >
                                {{ item.RoleName }}
                            </option>
                        </select>
                    </div>
                    <div class="btn-confirm" @click="confirmEvent">确认</div>
                </template>
                <template v-else>
                    <div class="tips">
                        未获取到您在【畅享版】的角色信息，赶紧登录《英雄年代》客户端完成创角吧！
                    </div>
                    <a href="#" target="_blank" class="download">立即下载</a>
                </template>
            </div>
        </div>
    </Transition>
    <Transition name="pop">
        <div id="confirmPop" class="pop" v-if="state.confirm.show">
            <div class="content">
                <span class="close" @click="state.confirm.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>确认绑定</h1>
                <h3>
                    您确认绑定角色为<strong>{{ state.bind.role }}</strong
                    >？
                </h3>
                <p>
                    每个盛趣通行证仅可选择一个角色参与
                    成团活动，且中途不能更换，请谨慎选择
                </p>
                <ul>
                    <li @click="cancelEvent">取消</li>
                    <li @click="submitEvent">确认</li>
                </ul>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { reactive, inject } from "vue";
import { GetRoles, BindRole } from "@/api";

const getMyInfo = inject("getMyInfo");

const state = reactive({
    bind: {
        show: false,
        role: "",
        list: []
    },
    confirm: {
        show: false
    }
});

// 确认事件
const confirmEvent = () => {
    if (!state.bind.role) {
        return CsGame.alert("请选择需要绑定的角色", 1200, "error");
    }
    state.confirm.show = true;
    state.bind.show = false;
};
// 取消事件
const cancelEvent = () => {
    state.bind.show = true;
    state.confirm.show = false;
};

// 提交事件
const submitEvent = async () => {
    const res = await BindRole(state.bind.role);
    if (res) {
        state.confirm.show = false;
        CsGame.alert("角色已成功绑定", 1200, "success");
        getMyInfo();
    }
};

defineExpose({
    Show: async () => {
        const res = await GetRoles();
        if (res) {
            state.bind.show = true;
            if (res.roles.length <= 0) {
                return false;
            }
            state.bind.list = res.roles;
        }
    }
});
</script>

<style lang="scss" scoped>
#bindPop {
    .select-wrapper {
        width: 360px;
        display: flex;
        margin: 0px auto 30px auto;
        select {
            width: 100%;
            background: none;
            height: 45px;
            border: 1px solid #8c392a;
            text-indent: 1em;
        }
    }
    .btn-confirm {
        width: 240px;
        height: 50px;
        margin: 0px auto 30px auto;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        color: #fff;
        font-size: 20px;
        border-radius: 6px;
        background: linear-gradient(to bottom, #86362c, #d6584b);
    }
    .tips {
        text-align: center;
        width: 400px;
        margin: 0px auto 20px auto;
        line-height: 1.4;
    }
    .download {
        text-decoration: none;
        display: block;
        width: 240px;
        height: 50px;
        margin: 0px auto 20px auto;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        color: #fff;
        font-size: 20px;
        border-radius: 6px;
        background: linear-gradient(to bottom, #86362c, #d6584b);
    }
}

#confirmPop {
    .content {
        h3 {
            font-size: 18px;
            text-align: center;
            margin-bottom: 12px;
            display: flex;
            justify-content: center;
            strong {
                color: #3c8a67;
                font-weight: bold;
                margin: 0px 5px;
            }
        }
        ul {
            display: flex;
            justify-content: center;
            padding-top: 10px;
            margin-bottom: 10px;
            li {
                width: 160px;
                text-align: center;
                line-height: 45px;
                height: 45px;
                margin: 0px 10px;
                border-radius: 6px;
                color: #fff;
                cursor: pointer;
                &:nth-of-type(1) {
                    background-color: #808080;
                }
                &:nth-of-type(2) {
                    background: linear-gradient(to bottom, #86362c, #d6584b);
                }
            }
        }
        p {
            width: 400px;
            padding: 10px;
            font-size: 14px;
            color: #7c241e;
            border: 1px dashed #7c241e;
            margin: 0px auto 10px auto;
        }
    }
}

#noRolePop {
    p {
        padding: 0px 30px;
        margin-bottom: 20px;
    }
    a {
        width: 240px;
        height: 50px;
        display: block;
        margin: 0px auto 20px auto;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        color: #fff;
        font-size: 20px;
        border-radius: 6px;
        background: linear-gradient(to bottom, #86362c, #d6584b);
    }
}
</style>
